/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AnswerOfferAiQuestionRequestDto } from '../models';
// @ts-ignore
import type { ApplyOfferAiProposalRequestDto } from '../models';
// @ts-ignore
import type { OfferAiChatMessagesResponseDto } from '../models';
// @ts-ignore
import type { OfferAiChatTurnResponseDto } from '../models';
// @ts-ignore
import type { OfferAiProposalDto } from '../models';
// @ts-ignore
import type { OfferAiQuestionDto } from '../models';
// @ts-ignore
import type { SendOfferAiChatMessageRequestDto } from '../models';
/**
 * RestOfferAiChatApi - axios parameter creator
 */
export const RestOfferAiChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Records what the user ticked on the card and sends it to the assistant as the user\'s next message, so the response is the same turn a typed message would produce. A card of kind SUBGROUPS takes subgroupIds; a card of kind DISH_SOURCES takes dishSources and ignoreEventType. A card can be answered once; when the assistant fails to reply, the card stays open for another try.
         * @summary Answer an assistant question card and run the assistant\'s next turn.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} questionId 
         * @param {AnswerOfferAiQuestionRequestDto} answerOfferAiQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerOfferAiChatQuestion: async (userId: string, processId: string, processOfferId: string, questionId: string, answerOfferAiQuestionRequestDto: AnswerOfferAiQuestionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('answerOfferAiChatQuestion', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('answerOfferAiChatQuestion', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('answerOfferAiChatQuestion', 'processOfferId', processOfferId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('answerOfferAiChatQuestion', 'questionId', questionId)
            // verify required parameter 'answerOfferAiQuestionRequestDto' is not null or undefined
            assertParamExists('answerOfferAiChatQuestion', 'answerOfferAiQuestionRequestDto', answerOfferAiQuestionRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/ai-chat/questions/{questionId}/answer`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{questionId}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(answerOfferAiQuestionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Applies only the items listed in the request, so a proposal can be taken in part. Recorded in the turn\'s change log, which means undoing that turn takes the additions back with it. A proposal can only be applied once. Every ticked item is priced for the offer before anything is written, so an item the catalogue cannot price refuses the whole request instead of leaving a half-applied proposal behind.
         * @summary Add the ticked items of an assistant proposal to the offer.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} proposalId 
         * @param {ApplyOfferAiProposalRequestDto} applyOfferAiProposalRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyOfferAiChatProposal: async (userId: string, processId: string, processOfferId: string, proposalId: string, applyOfferAiProposalRequestDto: ApplyOfferAiProposalRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('applyOfferAiChatProposal', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('applyOfferAiChatProposal', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('applyOfferAiChatProposal', 'processOfferId', processOfferId)
            // verify required parameter 'proposalId' is not null or undefined
            assertParamExists('applyOfferAiChatProposal', 'proposalId', proposalId)
            // verify required parameter 'applyOfferAiProposalRequestDto' is not null or undefined
            assertParamExists('applyOfferAiChatProposal', 'applyOfferAiProposalRequestDto', applyOfferAiProposalRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/ai-chat/proposals/{proposalId}/apply`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{proposalId}', encodeURIComponent(String(proposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyOfferAiProposalRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Dismiss an assistant proposal without adding anything.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} proposalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissOfferAiChatProposal: async (userId: string, processId: string, processOfferId: string, proposalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('dismissOfferAiChatProposal', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('dismissOfferAiChatProposal', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('dismissOfferAiChatProposal', 'processOfferId', processOfferId)
            // verify required parameter 'proposalId' is not null or undefined
            assertParamExists('dismissOfferAiChatProposal', 'proposalId', proposalId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/ai-chat/proposals/{proposalId}/dismiss`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{proposalId}', encodeURIComponent(String(proposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get conversation history for the offer-AI chat (per offer + current user).
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferAiChatMessages: async (userId: string, processId: string, processOfferId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getOfferAiChatMessages', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getOfferAiChatMessages', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('getOfferAiChatMessages', 'processOfferId', processOfferId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/ai-chat/messages`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send a user message; runs the AI tool-loop and returns the assistant reply.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {SendOfferAiChatMessageRequestDto} sendOfferAiChatMessageRequestDto Single user turn to send to the AI assistant.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOfferAiChatMessage: async (userId: string, processId: string, processOfferId: string, sendOfferAiChatMessageRequestDto: SendOfferAiChatMessageRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('sendOfferAiChatMessage', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('sendOfferAiChatMessage', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('sendOfferAiChatMessage', 'processOfferId', processOfferId)
            // verify required parameter 'sendOfferAiChatMessageRequestDto' is not null or undefined
            assertParamExists('sendOfferAiChatMessage', 'sendOfferAiChatMessageRequestDto', sendOfferAiChatMessageRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/ai-chat/messages`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendOfferAiChatMessageRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Close an assistant question card without answering it.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipOfferAiChatQuestion: async (userId: string, processId: string, processOfferId: string, questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('skipOfferAiChatQuestion', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('skipOfferAiChatQuestion', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('skipOfferAiChatQuestion', 'processOfferId', processOfferId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('skipOfferAiChatQuestion', 'questionId', questionId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/ai-chat/questions/{questionId}/skip`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{questionId}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restores the offer to the state captured before the turn\'s first write. Refuses with 409 when the offer changed after the turn (a manual edit or a later turn) — restoring then would silently discard that work. Changes the assistant made outside the offer (tasks, notes, e-mail drafts) are not covered and stay in place.
         * @summary Undo everything one assistant turn changed in the offer.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} turnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoOfferAiChatTurn: async (userId: string, processId: string, processOfferId: string, turnId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('undoOfferAiChatTurn', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('undoOfferAiChatTurn', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('undoOfferAiChatTurn', 'processOfferId', processOfferId)
            // verify required parameter 'turnId' is not null or undefined
            assertParamExists('undoOfferAiChatTurn', 'turnId', turnId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/ai-chat/turns/{turnId}/undo`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{turnId}', encodeURIComponent(String(turnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestOfferAiChatApi - functional programming interface
 */
export const RestOfferAiChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestOfferAiChatApiAxiosParamCreator(configuration)
    return {
        /**
         * Records what the user ticked on the card and sends it to the assistant as the user\'s next message, so the response is the same turn a typed message would produce. A card of kind SUBGROUPS takes subgroupIds; a card of kind DISH_SOURCES takes dishSources and ignoreEventType. A card can be answered once; when the assistant fails to reply, the card stays open for another try.
         * @summary Answer an assistant question card and run the assistant\'s next turn.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} questionId 
         * @param {AnswerOfferAiQuestionRequestDto} answerOfferAiQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async answerOfferAiChatQuestion(userId: string, processId: string, processOfferId: string, questionId: string, answerOfferAiQuestionRequestDto: AnswerOfferAiQuestionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferAiChatTurnResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.answerOfferAiChatQuestion(userId, processId, processOfferId, questionId, answerOfferAiQuestionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferAiChatApi.answerOfferAiChatQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Applies only the items listed in the request, so a proposal can be taken in part. Recorded in the turn\'s change log, which means undoing that turn takes the additions back with it. A proposal can only be applied once. Every ticked item is priced for the offer before anything is written, so an item the catalogue cannot price refuses the whole request instead of leaving a half-applied proposal behind.
         * @summary Add the ticked items of an assistant proposal to the offer.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} proposalId 
         * @param {ApplyOfferAiProposalRequestDto} applyOfferAiProposalRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyOfferAiChatProposal(userId: string, processId: string, processOfferId: string, proposalId: string, applyOfferAiProposalRequestDto: ApplyOfferAiProposalRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferAiProposalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyOfferAiChatProposal(userId, processId, processOfferId, proposalId, applyOfferAiProposalRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferAiChatApi.applyOfferAiChatProposal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Dismiss an assistant proposal without adding anything.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} proposalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dismissOfferAiChatProposal(userId: string, processId: string, processOfferId: string, proposalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferAiProposalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dismissOfferAiChatProposal(userId, processId, processOfferId, proposalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferAiChatApi.dismissOfferAiChatProposal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get conversation history for the offer-AI chat (per offer + current user).
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfferAiChatMessages(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferAiChatMessagesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfferAiChatMessages(userId, processId, processOfferId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferAiChatApi.getOfferAiChatMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send a user message; runs the AI tool-loop and returns the assistant reply.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {SendOfferAiChatMessageRequestDto} sendOfferAiChatMessageRequestDto Single user turn to send to the AI assistant.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendOfferAiChatMessage(userId: string, processId: string, processOfferId: string, sendOfferAiChatMessageRequestDto: SendOfferAiChatMessageRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferAiChatTurnResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendOfferAiChatMessage(userId, processId, processOfferId, sendOfferAiChatMessageRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferAiChatApi.sendOfferAiChatMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Close an assistant question card without answering it.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skipOfferAiChatQuestion(userId: string, processId: string, processOfferId: string, questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferAiQuestionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skipOfferAiChatQuestion(userId, processId, processOfferId, questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferAiChatApi.skipOfferAiChatQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restores the offer to the state captured before the turn\'s first write. Refuses with 409 when the offer changed after the turn (a manual edit or a later turn) — restoring then would silently discard that work. Changes the assistant made outside the offer (tasks, notes, e-mail drafts) are not covered and stay in place.
         * @summary Undo everything one assistant turn changed in the offer.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} turnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoOfferAiChatTurn(userId: string, processId: string, processOfferId: string, turnId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoOfferAiChatTurn(userId, processId, processOfferId, turnId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferAiChatApi.undoOfferAiChatTurn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestOfferAiChatApi - factory interface
 */
export const RestOfferAiChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestOfferAiChatApiFp(configuration)
    return {
        /**
         * Records what the user ticked on the card and sends it to the assistant as the user\'s next message, so the response is the same turn a typed message would produce. A card of kind SUBGROUPS takes subgroupIds; a card of kind DISH_SOURCES takes dishSources and ignoreEventType. A card can be answered once; when the assistant fails to reply, the card stays open for another try.
         * @summary Answer an assistant question card and run the assistant\'s next turn.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} questionId 
         * @param {AnswerOfferAiQuestionRequestDto} answerOfferAiQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerOfferAiChatQuestion(userId: string, processId: string, processOfferId: string, questionId: string, answerOfferAiQuestionRequestDto: AnswerOfferAiQuestionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferAiChatTurnResponseDto> {
            return localVarFp.answerOfferAiChatQuestion(userId, processId, processOfferId, questionId, answerOfferAiQuestionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Applies only the items listed in the request, so a proposal can be taken in part. Recorded in the turn\'s change log, which means undoing that turn takes the additions back with it. A proposal can only be applied once. Every ticked item is priced for the offer before anything is written, so an item the catalogue cannot price refuses the whole request instead of leaving a half-applied proposal behind.
         * @summary Add the ticked items of an assistant proposal to the offer.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} proposalId 
         * @param {ApplyOfferAiProposalRequestDto} applyOfferAiProposalRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyOfferAiChatProposal(userId: string, processId: string, processOfferId: string, proposalId: string, applyOfferAiProposalRequestDto: ApplyOfferAiProposalRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferAiProposalDto> {
            return localVarFp.applyOfferAiChatProposal(userId, processId, processOfferId, proposalId, applyOfferAiProposalRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dismiss an assistant proposal without adding anything.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} proposalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissOfferAiChatProposal(userId: string, processId: string, processOfferId: string, proposalId: string, options?: RawAxiosRequestConfig): AxiosPromise<OfferAiProposalDto> {
            return localVarFp.dismissOfferAiChatProposal(userId, processId, processOfferId, proposalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get conversation history for the offer-AI chat (per offer + current user).
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferAiChatMessages(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig): AxiosPromise<OfferAiChatMessagesResponseDto> {
            return localVarFp.getOfferAiChatMessages(userId, processId, processOfferId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send a user message; runs the AI tool-loop and returns the assistant reply.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {SendOfferAiChatMessageRequestDto} sendOfferAiChatMessageRequestDto Single user turn to send to the AI assistant.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOfferAiChatMessage(userId: string, processId: string, processOfferId: string, sendOfferAiChatMessageRequestDto: SendOfferAiChatMessageRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferAiChatTurnResponseDto> {
            return localVarFp.sendOfferAiChatMessage(userId, processId, processOfferId, sendOfferAiChatMessageRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Close an assistant question card without answering it.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipOfferAiChatQuestion(userId: string, processId: string, processOfferId: string, questionId: string, options?: RawAxiosRequestConfig): AxiosPromise<OfferAiQuestionDto> {
            return localVarFp.skipOfferAiChatQuestion(userId, processId, processOfferId, questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Restores the offer to the state captured before the turn\'s first write. Refuses with 409 when the offer changed after the turn (a manual edit or a later turn) — restoring then would silently discard that work. Changes the assistant made outside the offer (tasks, notes, e-mail drafts) are not covered and stay in place.
         * @summary Undo everything one assistant turn changed in the offer.
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} turnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoOfferAiChatTurn(userId: string, processId: string, processOfferId: string, turnId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.undoOfferAiChatTurn(userId, processId, processOfferId, turnId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestOfferAiChatApi - interface
 */
export interface RestOfferAiChatApiInterface {
    /**
     * Records what the user ticked on the card and sends it to the assistant as the user\'s next message, so the response is the same turn a typed message would produce. A card of kind SUBGROUPS takes subgroupIds; a card of kind DISH_SOURCES takes dishSources and ignoreEventType. A card can be answered once; when the assistant fails to reply, the card stays open for another try.
     * @summary Answer an assistant question card and run the assistant\'s next turn.
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {string} questionId 
     * @param {AnswerOfferAiQuestionRequestDto} answerOfferAiQuestionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    answerOfferAiChatQuestion(userId: string, processId: string, processOfferId: string, questionId: string, answerOfferAiQuestionRequestDto: AnswerOfferAiQuestionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferAiChatTurnResponseDto>;

    /**
     * Applies only the items listed in the request, so a proposal can be taken in part. Recorded in the turn\'s change log, which means undoing that turn takes the additions back with it. A proposal can only be applied once. Every ticked item is priced for the offer before anything is written, so an item the catalogue cannot price refuses the whole request instead of leaving a half-applied proposal behind.
     * @summary Add the ticked items of an assistant proposal to the offer.
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {string} proposalId 
     * @param {ApplyOfferAiProposalRequestDto} applyOfferAiProposalRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applyOfferAiChatProposal(userId: string, processId: string, processOfferId: string, proposalId: string, applyOfferAiProposalRequestDto: ApplyOfferAiProposalRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferAiProposalDto>;

    /**
     * 
     * @summary Dismiss an assistant proposal without adding anything.
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {string} proposalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dismissOfferAiChatProposal(userId: string, processId: string, processOfferId: string, proposalId: string, options?: RawAxiosRequestConfig): AxiosPromise<OfferAiProposalDto>;

    /**
     * 
     * @summary Get conversation history for the offer-AI chat (per offer + current user).
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferAiChatMessages(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig): AxiosPromise<OfferAiChatMessagesResponseDto>;

    /**
     * 
     * @summary Send a user message; runs the AI tool-loop and returns the assistant reply.
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {SendOfferAiChatMessageRequestDto} sendOfferAiChatMessageRequestDto Single user turn to send to the AI assistant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendOfferAiChatMessage(userId: string, processId: string, processOfferId: string, sendOfferAiChatMessageRequestDto: SendOfferAiChatMessageRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferAiChatTurnResponseDto>;

    /**
     * 
     * @summary Close an assistant question card without answering it.
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {string} questionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    skipOfferAiChatQuestion(userId: string, processId: string, processOfferId: string, questionId: string, options?: RawAxiosRequestConfig): AxiosPromise<OfferAiQuestionDto>;

    /**
     * Restores the offer to the state captured before the turn\'s first write. Refuses with 409 when the offer changed after the turn (a manual edit or a later turn) — restoring then would silently discard that work. Changes the assistant made outside the offer (tasks, notes, e-mail drafts) are not covered and stay in place.
     * @summary Undo everything one assistant turn changed in the offer.
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {string} turnId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    undoOfferAiChatTurn(userId: string, processId: string, processOfferId: string, turnId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestOfferAiChatApi - object-oriented interface
 */
export class RestOfferAiChatApi extends BaseAPI implements RestOfferAiChatApiInterface {
    /**
     * Records what the user ticked on the card and sends it to the assistant as the user\'s next message, so the response is the same turn a typed message would produce. A card of kind SUBGROUPS takes subgroupIds; a card of kind DISH_SOURCES takes dishSources and ignoreEventType. A card can be answered once; when the assistant fails to reply, the card stays open for another try.
     * @summary Answer an assistant question card and run the assistant\'s next turn.
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {string} questionId 
     * @param {AnswerOfferAiQuestionRequestDto} answerOfferAiQuestionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public answerOfferAiChatQuestion(userId: string, processId: string, processOfferId: string, questionId: string, answerOfferAiQuestionRequestDto: AnswerOfferAiQuestionRequestDto, options?: RawAxiosRequestConfig) {
        return RestOfferAiChatApiFp(this.configuration).answerOfferAiChatQuestion(userId, processId, processOfferId, questionId, answerOfferAiQuestionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Applies only the items listed in the request, so a proposal can be taken in part. Recorded in the turn\'s change log, which means undoing that turn takes the additions back with it. A proposal can only be applied once. Every ticked item is priced for the offer before anything is written, so an item the catalogue cannot price refuses the whole request instead of leaving a half-applied proposal behind.
     * @summary Add the ticked items of an assistant proposal to the offer.
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {string} proposalId 
     * @param {ApplyOfferAiProposalRequestDto} applyOfferAiProposalRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public applyOfferAiChatProposal(userId: string, processId: string, processOfferId: string, proposalId: string, applyOfferAiProposalRequestDto: ApplyOfferAiProposalRequestDto, options?: RawAxiosRequestConfig) {
        return RestOfferAiChatApiFp(this.configuration).applyOfferAiChatProposal(userId, processId, processOfferId, proposalId, applyOfferAiProposalRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Dismiss an assistant proposal without adding anything.
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {string} proposalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dismissOfferAiChatProposal(userId: string, processId: string, processOfferId: string, proposalId: string, options?: RawAxiosRequestConfig) {
        return RestOfferAiChatApiFp(this.configuration).dismissOfferAiChatProposal(userId, processId, processOfferId, proposalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get conversation history for the offer-AI chat (per offer + current user).
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOfferAiChatMessages(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig) {
        return RestOfferAiChatApiFp(this.configuration).getOfferAiChatMessages(userId, processId, processOfferId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send a user message; runs the AI tool-loop and returns the assistant reply.
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {SendOfferAiChatMessageRequestDto} sendOfferAiChatMessageRequestDto Single user turn to send to the AI assistant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendOfferAiChatMessage(userId: string, processId: string, processOfferId: string, sendOfferAiChatMessageRequestDto: SendOfferAiChatMessageRequestDto, options?: RawAxiosRequestConfig) {
        return RestOfferAiChatApiFp(this.configuration).sendOfferAiChatMessage(userId, processId, processOfferId, sendOfferAiChatMessageRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Close an assistant question card without answering it.
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {string} questionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skipOfferAiChatQuestion(userId: string, processId: string, processOfferId: string, questionId: string, options?: RawAxiosRequestConfig) {
        return RestOfferAiChatApiFp(this.configuration).skipOfferAiChatQuestion(userId, processId, processOfferId, questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restores the offer to the state captured before the turn\'s first write. Refuses with 409 when the offer changed after the turn (a manual edit or a later turn) — restoring then would silently discard that work. Changes the assistant made outside the offer (tasks, notes, e-mail drafts) are not covered and stay in place.
     * @summary Undo everything one assistant turn changed in the offer.
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {string} turnId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public undoOfferAiChatTurn(userId: string, processId: string, processOfferId: string, turnId: string, options?: RawAxiosRequestConfig) {
        return RestOfferAiChatApiFp(this.configuration).undoOfferAiChatTurn(userId, processId, processOfferId, turnId, options).then((request) => request(this.axios, this.basePath));
    }
}

